import correct from '@/assets/img/documents/sales-contract.jpg';
import wrong from '@/assets/img/documents/sales-contract-wrong.jpg';
import Card from '@/components/Card';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const SALES_CONTRACT_NAME = 'sales_contract';

const SalesContract = () => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać umowę sprzedaży?'),
    steps: [
      i18n.t('Upewnij się, że wszystkie dane pojazdu są widoczne.'),
      i18n.t('Sprawdź, czy załączasz wszystkie strony umowy.'),
      i18n.t('Jeśli przesyłasz zdjęcia – sprawdź, czy dokument jest czytelny.'),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  return (
    <div>
      <Card>
        <Uploader
          title={i18n.t('Umowa sprzedaży pojazdu')}
          instructionProps={instructionProps}
          inputFieldName={SALES_CONTRACT_NAME}
          required
          attachmentTypeId={ATTACHMENT_TYPES.UMOWA_KUPNASPRZEDAZY}
        />
      </Card>
    </div>
  );
};

export default SalesContract;
